import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducers/reducers';

const loadState = () => {
    try {
      const serializedState = sessionStorage.getItem('state');
      if(serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (e) {
      return undefined;
    }
  };
  
  const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      sessionStorage.setItem('state', serializedState);
    } catch (e) {
      throw e;
    }
  };
  
  const persistedState = loadState();
  const middleware = [thunk];
  const store = createStore(rootReducer, persistedState, composeWithDevTools(applyMiddleware(...middleware)));
  
  store.subscribe(() => {
    saveState(store.getState());
  });
  
  
  export default store;